<template>
  <div class="w-full pt-8 px-8 flex flex-col justify-center">
    <h1 class="text-cw-900">{{ modalTitle }}</h1>
    <!-- <h6 class="mb-8 text-sm">Are you an organisation wanting to sign up and share your content to the cloud? <a class="ml-2 hover:text-cw-alt" :href="settings.cloud_url">Click here</a></h6> -->

    <div class="grid grid-cols-1 gap-8 mt-8">
      <div class="space-y-6 w-full">
        <!-- Name -->
        <div :class="inputWrapperClass" class="h-12">
          <h6 :class="inputLabelClass">
            List name <span class="italic">required</span>
          </h6>
          <input
            id="name"
            v-model="name"
            type="text"
            name="name"
            autocomplete="name"
            :class="[inputTextClass, inputTextColor]"
            :disabled="nameDisabled"
          />
        </div>
        <!-- /Name -->

        <!-- Address -->
        <!--
          <div :class='inputWrapperClass' class='h-12'>
          <h6 :class='inputLabelClass'>Sending address <span class="italic">required</span></h6>
          <input
          v-model="address" 
          type="text" 
          name="address" 
          id="address" 
          autocomplete="address" 
          :class='inputTextClass' />
          </div> 
        -->
        <!-- /Address -->
      </div>
    </div>

    <!-- Actions -->
    <div class="grid grid-cols-1 mt-6">
      <div class="w-full flex items-center justify-center mt-10">
        <button
          type="button"
          :disabled="!canSubmit || thinking"
          class="btn btn-primary relative w-40 m-0"
          :class="{
            'opacity-25 cursor-not-allowed': !canSubmit,
          }"
          @click="onSubmit"
        >
          <div
            class="absolute inset-0 w-full flex justify-center items-center z-20"
          >
            <lottie v-if="thinking" :options="loadingAnimationOptions" />
          </div>
          <div
            :class="[
              thinking ? 'invisible' : '',
              'w-full flex items-center justify-center capitalize',
            ]"
          >
            {{ action }}
          </div>
        </button>
      </div>
    </div>
    <!-- /Actions -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { EventBus } from '../../../../../../js/plugins/event-bus.js'
import * as loadingAnimation from '../../../../../../shared/components/loading.json'

export default {
  props: {
    config: { default: null },
  },

  data() {
    return {
      loadingAnimationOptions: { animationData: loadingAnimation.default },
      thinking: false,
      // config/form
      action: this.config.action || 'create',
      modalTitle: this.config.title || 'Create a new list',
      name: this.config.list?.name || null,
      address: this.config.list?.address || null,
      // styles
      inputWrapperClass:
        'rounded relative bg-white border border-truegray-300 ',
      inputLabelClass:
        'absolute transform duration-100 ease-linear px-1 left-3 top-1 z-40 text-truegray-700',
      inputTextClass:
        'flex-grow px-4 mr-0 mt-1 outline-none focus:outline-none bg-transparent w-full h-12 font-primary focus:placeholder-truegray-300',
      inputTextColor: this.config?.list?.undeletable
        ? 'text-gray-500'
        : 'text-black',
    }
  },

  computed: {
    canSubmit() {
      return !!this.name?.trim() // && !!this.address?.trim()
    },

    nameDisabled() {
      return !!this.config.list?.undeletable
    },

    payload() {
      const payload = {
        id: this.config.list?.id || null,
        name: this.name?.trim(),
        sending_address: this.address?.trim(),
      }

      return payload
    },
  },

  methods: {
    ...mapActions({
      dispatchCreateMailList: 'careerwise/dispatchCreateMailList',
      dispatchUpdateMailList: 'careerwise/dispatchUpdateMailList',
    }),

    async onSubmit() {
      if (this.canSubmit) {
        this.$set(this, 'thinking', true)
        if (this.action === 'create') {
          await this.dispatchCreateMailList(this.payload)
        } else {
          await this.dispatchUpdateMailList(this.payload)
        }
        this.$set(this, 'thinking', false)
        EventBus.$emit('showModal', false)
      }
    },
  },
}
</script>
